import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "gameControlsTabIndex",
  initialState: 0, // 0=Manual, 1=Auto
  reducers: {
    setGameControlsTabIndex: (state, action) => {
      const next = Number(action.payload);
      return next === 1 ? 1 : 0;
    },
  },
});

export const { setGameControlsTabIndex } = slice.actions;
export default slice.reducer;
